import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';
import CountDownSet from '../count-set';

export default Vue.component('edit-countdown', {
  template: require('./template.html'),
  mixins: [guid],
  computed: {
    ...mapGetters(['currentSite', 'viewport']),
    sets() {
      return this.droplet.clock.sets;
    },
  },
  components: {
    CountDownSet,
  },
  data() {
    return {
      paginate: ['sets'],
      selectedItem: 0,
    };
  },
  name: 'edit-countdown',
  props: ['droplet', 'show-edit-bubble'],
  methods: {
    changeSelectedSet(i) {
      this.selectedItem = i;
    },
    addSet() {
      const payload = {};
      payload.drp = this.droplet;
      payload.set = {
        _id: this.guid(),
        endDate: {
          date: new Date(),
        },
        endTime: {
          hh: '11',
          HH: '11',
          mm: '59',
          A: 'PM',
        },
        bufferTime: 0,
        bufferDur: 'seconds',
        endMessage: 'Countdown Ended!',
        recurring: false,
      };
      this.promise(this.$store.dispatch('addCountdownSet', payload), 'adding set');
      this.selectedItem = 0;
    },
    tempEnd() {
      const tempDate = new Date((new Date().getTime() + 1) * (24 * 60 * 60 * 1000));
      return tempDate;
    },
    closeDatePicker() {
      const sets = this.$refs.countSet;
      _.forEach(sets, (value) => {
        const picker = value.$refs.setPicker;
        if (!_.isUndefined(picker.clickOutside)) {
          picker.clickOutside(event);
        }
      });
    },
    setLocals(v) {
      this.$emit('set-display', v);
    },
    emitSetsString() {
      this.$emit('update-set-string');
    },
    promise(action, error) {
      const promise = new Promise((resolve, reject) => {
        if (action) {
          resolve();
        } else {
          reject(Error(`Error in countdown: ${error}`));
        }
      });
      promise.then(() => {
        this.$emit('update-set-string');
        // so we won't see a flicker in the jquery plugin
        setTimeout(() => {
          this.$vnode.context.unBindPlugin();
        }, 100);
      });
    },
    drzRevertData() {
      this.$emit('css-generator');
      this.$emit('update-set-string');
      this.$vnode.context.unBindPlugin();
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/countdown/components/_edit-options/index.js